module.exports = __webpack_public_path__ + "img/t2-2.c9c8b435.svg";